<template>
  <div
    class="badge label"
    :class="[
      $blockClass(blockClass, 'badge'),
      modifierClasses,
    ]"
    v-text="label"
  />
</template>

<script>

/**
 * Vue: Badge (badge)
 * -----------------------------------------------------------------------------
 * A badge component.
 *
 * @param {String} blockClass - Block level class to apply to all elements.
 * @param {String} label - Badge label.
 * @param {String} [modifiers] - Badge modifiers in space separated list
 * (supports: pink)
 */

export default {
  name: 'Badge',
  props: {
    blockClass: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
      required: true,
    },
    modifiers: {
      type: [String, Array],
      default: '',
    },
  },

  data() {
    return {
      global: true,
    }
  },

  computed: {

    /**
     * Compute modifier classes.
     * @returns {String}
     */
    modifierClasses() {
      if (!this.modifiers) {
        return ''
      }

      let modifiers = []

      if (Array.isArray(this.modifiers)) {
        const combined =  this.modifiers.map((el) => {
          if(!el.includes(' ')) {
            return el
          }

          return el.split(' ')
        })

        modifiers = combined.flat()
      } else {
        modifiers = this.modifiers.split(' ')
      }

      return modifiers.map((modifier) => {
        return `badge--${modifier}`
      }).join(' ')
    },
  },
}
</script>
